export default "__VITE_ASSET__uI3ws3ru__"